<template>
  <div>
    <slot :events="{ inputHasChanged }">

      <v-select
        v-model="selected"
        :placeholder="$t('order.label.address.search')"
        :options="results"
        :filterable="false"
        :clearable="false"
        :get-option-label="getOptionLabel"
        @search="inputHasChanged"
        @option:selected="resultHasBeenSelected"
      >
        <span
          slot="no-options"
          class="text-center"
        >
          {{ $t('shared.write-something') }}
        </span>
      </v-select>

    </slot>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {

  name: 'GooglePlacesAutocomplete',

  components: {
    vSelect,
  },

  props: {

    value: {
      type: String,
      required: false,
      default: '',
    },

    locationTypes: {
      type: Array,
      required: false,
      default: () => ([]),
    },

  },

  data() {
    return {
      autocompleteSuggestion: null,
      sessionToken: null,
      results: [],
      selected: null,
      googleMapsApiKey: 'AIzaSyB5zbQZqenSwG_xowvr2lQ4_HfU_ZD-CQY',
      googleMapsLanguage: 'pl',
      googleMapsRegion: 'PL',
    }
  },

  beforeMount() {
    if (!this.autocompleteSuggestion) {
      this.initGoogleAutoCompleteService()
    }
  },

  methods: {

    async initGoogleAutoCompleteService() {
      await this.loadGoogleMapsApi()

      const placesLibrary = await window.google.maps.importLibrary('places')
      this.autocompleteSuggestion = placesLibrary.AutocompleteSuggestion
      this.sessionToken = new placesLibrary.AutocompleteSessionToken()
    },

    loadGoogleMapsApi() {
      if (window.google?.maps?.importLibrary) {
        return Promise.resolve()
      }

      if (window.googleMapsApiLoadingPromise) {
        return window.googleMapsApiLoadingPromise
      }

      window.googleMapsApiLoadingPromise = new Promise((resolve, reject) => {
        const callbackName = '__googleMapsApiLoaded'
        const existingScript = document.querySelector('script[data-google-maps-api="true"]')

        window[callbackName] = () => {
          resolve()
          delete window[callbackName]
        }

        if (existingScript) {
          existingScript.addEventListener('load', resolve, { once: true })
          existingScript.addEventListener('error', reject, { once: true })
          return
        }

        const script = document.createElement('script')
        script.async = true
        script.defer = true
        script.dataset.googleMapsApi = 'true'
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.googleMapsApiKey}&v=weekly&language=${this.googleMapsLanguage}&region=${this.googleMapsRegion}&libraries=places&loading=async&callback=${callbackName}`
        script.onerror = reject

        document.head.appendChild(script)
      })

      return window.googleMapsApiLoadingPromise
    },

    async inputHasChanged(input) {
      if (!input || !this.autocompleteSuggestion || !this.sessionToken) return

      const request = {
        input,
        sessionToken: this.sessionToken,
        language: this.googleMapsLanguage,
        region: this.googleMapsRegion.toLowerCase(),
      }

      const { suggestions } = await this.autocompleteSuggestion.fetchAutocompleteSuggestions(request)
      this.results = Array.isArray(suggestions) ? suggestions : []
    },

    async resultHasBeenSelected(selected) {
      const placesLibrary = await window.google.maps.importLibrary('places')
      const placePrediction = selected?.placePrediction || null
      const place = placePrediction?.toPlace ? placePrediction.toPlace() : null
      if (!place) {
        this.selected = null
        return
      }

      await place.fetchFields({
        fields: ['displayName', 'types', 'addressComponents'],
      })

      this.$emit('place:changed', this.normalizePlaceForLegacyAddressForm(place))
      this.selected = null
      this.sessionToken = new placesLibrary.AutocompleteSessionToken()
    },

    getOptionLabel(option) {
      if (option?.placePrediction?.text) {
        return option.placePrediction.text.toString()
      }

      return option?.description || ''
    },
    normalizePlaceForLegacyAddressForm(place) {
      return {
        name: place?.displayName || '',
        types: Array.isArray(place?.types) ? place.types : [],
        address_components: this.normalizeAddressComponents(place?.addressComponents),
      }
    },
    normalizeAddressComponents(addressComponents) {
      if (!Array.isArray(addressComponents)) {
        return []
      }

      return addressComponents.map(component => ({
        long_name: component?.longText || component?.long_name || '',
        short_name: component?.shortText || component?.short_name || '',
        types: Array.isArray(component?.types) ? component.types : [],
      }))
    },

  },

}
</script>
